module.exports = __webpack_public_path__ + "static/media/veryvell_1.2669296d.png";